import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(({ spacing, palette }) => ({
  filterCategory: {
    display: "flex",
    flexDirection: "column",
  },
  options: {
    display: "flex",
    flexDirection: "column",
    minHeight: spacing(33),
  },
  title: {
    color: palette.grey[500],
    textTransform: "none",
  },
}));

export default useStyles;
